'use client';

import dynamic from 'next/dynamic';

const WebWelcomeBonus = dynamic(() => { return import('@/components/marketingLanding/components/WebWelcomeBonus'); }, {
  loading: () => { return <p>Loading...</p>; },
});

const WelcomeBonus = () => {
  return <WebWelcomeBonus />;
};

export default WelcomeBonus;
